import axios from 'axios'
import Vue from 'vue'
import qs from "qs";

const state = {
    contacts: [],
    dismiss: [],
    editContact: [],
    editGroup: [],
    userSectRightLoader: false,
}

const getters = {}

const mutations = {
    setContacts(state, data) {
        if (typeof data === 'object' && data.items !== undefined) {
            Vue.set(state,'contacts', data.items);
            Vue.set(state,'dismiss', data.dismiss);
        }
    },
    setEditContact(state, data) {
        state.editContact = data;
    },
    addContact(state, data){
        for (let i in state.contacts) {
            if(state.contacts[i].id == data.group){
                state.contacts[i].contacts.push(data);
                state.contacts[i].contacts.sort(function (a, b) {
                    if (a.keyword > b.keyword) {
                        return 1;
                    }
                    if (a.keyword < b.keyword) {
                        return -1;
                    }
                    return 0;
                });
            }
        }

    },
    refreshContact(state, data){
        for (let i in state.contacts) {
            if(state.contacts[i].id == data.group){
                for (let k in state.contacts[i].contacts) {
                    if(state.contacts[i].contacts[k].id == data.id){
                        state.contacts[i].contacts[k] = data;
                    }
                }
            }    
        }
    },
    removeContact(state, data){
        for (let i in state.contacts) {
            for (let k in state.contacts[i].contacts) {
                if(state.contacts[i].contacts[k].id == data){
                    state.contacts[i].contacts.splice(k, 1);
                }
            } 
        }
    },
    removeGroup(state, data){
        let index = state.contacts.findIndex(sect => sect.id === data);
        state.contacts.splice(index, 1);
    },
    contactBlock(state, data){
        for (let i in state.contacts) {
            for (let k in state.contacts[i].contacts) {
                if(state.contacts[i].contacts[k].id == data){
                    state.contacts[i].contacts[k].banned = true;
                }
            }
        }
        state.editContact.banned = true;
    },
    moveUpGroup(state, data){
        if (data === 0) { // if its the first in the array
            state.contacts.push(state.contacts.shift()) // same as option 1
        } else {
            let array = state.contacts.map((element, i) => { // iterate array and change places
                if (i === data - 1) {
                    return state.contacts[data];
                } else if (i === data) {
                    return state.contacts[data - 1];
                } else {
                    return element;
                }
            });
            state.contacts = array;
        }
    },
    moveDownGroup(state, data){
        if (data === state.contacts.length-1) { // if its the last in the array
            state.contacts.unshift(state.contacts.pop()) // same as option 1
        } else {
            let array = state.contacts.map((element, i) => { // iterate array and change places
                if (i === data) {
                    return state.contacts[data + 1];
                } else if (i === data + 1) {
                    return state.contacts[data];
                } else {
                    return element;
                }
            });
            state.contacts = array;
        }
    },
    moveGroup(state, data){
        state.contacts = data;
    },
    setEditGroup(state, data){
        state.editGroup = data; 
    },
    renameGroup(state, data){
        let index = state.contacts.findIndex(sect => sect.id === data.id);
        state.contacts[index].name = data.name;
    },
    addGroup(state, data){
        state.contacts.push(data);
    },
}

let config = function (params) {
    let result = {
        headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
        withCredentials: true,
        paramsSerializer: function(params) {
            return qs.stringify(params, {arrayFormat: 'repeat'})
        },
    }
    if(params){
        result.params =  params
    }
    return result;
}

const actions = {
    getContacts(context, data) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_PATH + '/rules/contacts/', config())
                .then(response => {
                if (typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('setContacts', response.data.result);
                } else {
                    if (+response.data.error === 401) {
                        if (response.data.result.user.login === null) {
                            context.dispatch('auth/logout',{},{root:true})
                        } else {
                            context.commit('auth/setIsNoSuccessSection', {}, {root: true})
                        }
                    }
                }
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    add(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/contacts/';
            if(data.id){
                url +=  data.id+'/';
            }
            let paramsData = data;

            let formData = new FormData();
            for ( let key in data.form ) {
                formData.append(key, data.form[key]);
            }

            axios.post(url, formData, config()).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    if(response.data.result.status != 'error'){
                        if(paramsData.id){
                            if(context.state.editContact.group == response.data.result.item.group){
                                context.commit('refreshContact',  response.data.result.item);
                            }
                            else{
                                context.commit('removeContact',  paramsData.id);
                                context.commit('addContact',  response.data.result.item);
                            }

                        }else{
                            context.commit('addContact',  response.data.result.item);
                        }
                    }

                }
                resolve(response.data.result);
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    contactBlock(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/contacts/';
            if(data.id){
                url +=  data.id+'/';
            }
            let formData = new FormData();
            formData.append('type','contactBlock')
            axios.post(url, formData, config()).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('contactBlock',  data.id);
                }
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    setMoveGroup(context, data){
        return new Promise((resolve, reject) => {

            if(data.direction == 'up'){
                context.commit('moveUpGroup',data.index);
            } else{
                context.commit('moveDownGroup',data.index);    
            }
            let url = process.env.VUE_APP_API_PATH+'/rules/contacts/';
            let formData = new FormData();
            let ids = [];
            formData.append('type', 'setGroupSort');
            for (let i in context.state.contacts) {
                ids.push(context.state.contacts[i].id);
            }
            formData.append('ids', JSON.stringify(ids));

            axios.post(url, formData, config())
                .then(response => {
                    resolve();
                }).catch(function (error) {
                    context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                    resolve();
                });
        });   
    },
    setGroupSort(context, data){
        return new Promise((resolve, reject) => {

            context.commit('moveGroup', data);
            let url = process.env.VUE_APP_API_PATH+'/rules/contacts/';
            let formData = new FormData();
            let ids = [];
            formData.append('type', 'setGroupSort');
            for (let i in context.state.contacts) {
                ids.push(context.state.contacts[i].id);
            }
            formData.append('ids', JSON.stringify(ids));

            axios.post(url, formData, config())
                .then(response => {
                    resolve();
                }).catch(function (error) {
                    context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                    resolve();
                });
        });
    },
    setGroup(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/contacts/';
            if(data.id){
                url +=  data.id+'/';
            }

            let formData = new FormData();
            formData.append('name', data.name);
            formData.append('type', 'saveGroup');

            axios.post(url,formData, config())
                .then(response => {
                    if(typeof response.data === 'object' && +response.data.error === 0) {
                        if(data.id){
                            context.commit('renameGroup',  data);
                        } else{
                            context.commit('addGroup',  response.data.result.items);
                        }
                        resolve();
                    }
                }).catch(function (error) {
                    context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                });
        });
    },
    removeGroup(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/contacts/'+data.id+'/';
            let formData = new FormData();
            formData.append('type', 'removeGroup'); 

            axios.post(url, formData, config()).then(response => {
                if(response.data.result){
                    context.commit('removeGroup',data.id);   
                    resolve(true);
                }else{
                    resolve(false);
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}